import React from 'react'
import { useTranslation } from 'react-i18next'
import { SECTION } from 'utils/section'
import { ConceptBlock } from './partials/ConceptBlock'
import symbol from 'assets/img/symbol-orange.svg'
import styles from './Concept.module.scss'

export const Concept = () => {
  const { t } = useTranslation()
  return (
    <section id={SECTION.CONCEPT} className={styles['section']}>
      <div className={styles['container']}>
        <img className={styles['symbol']} src={symbol} alt="PreFor" />
        <h5 className={styles['slogan']}>{t('company.slogan')}</h5>
        <h2 className={styles['title']}>{t('concept.title')}</h2>
        {Array.from(Array(5), (e, i) => {
          return <ConceptBlock key={i} number={i+1} />
        })}
      </div>
    </section>
  )
}
